import { BaseApi } from '@/modules/core/base.api';
import { Tag } from '@/modules/tag/tag';
import { Agency } from '@/modules/agency/agency';
import { User } from '@/modules/user/user';
import * as API from '@shared/common/api';
import { PaginationResult } from '@shared/common/types';

class TagApi extends BaseApi {
    public apiPath = 'tag';

    public async findAll(options: object & { page: number }): Promise<PaginationResult<Tag>>;
    public async findAll(options?: object): Promise<Tag[]>;
    public async findAll(options: any = {}): Promise<Tag[] | PaginationResult<Tag>> {
        const response = await this.api.get(this.baseUrlFor(), {
            params: {
                ...options,
            },
        });

        if (response.data.items) {
            response.data.items = response.data.items.map((tag: any) => this.createInstance(tag));
        } else {
            response.data = response.data.map((tag: any) => this.createInstance(tag));
        }


        return response.data;
    }

    public async create(tag: any): Promise<API.CreateTag> {
        const response = await this.api.post<API.CreateTag>(this.baseUrlFor(), tag);
        return response.data;
    }

    public async update(tag: any): Promise<API.UpdateTag> {
        const response = await this.api.put<API.UpdateTag>(this.baseUrlFor(tag.id), tag);
        return response.data;
    }

    public async get(id: string): Promise<API.GetTag> {
        const response = await this.api.get<API.GetTag>(this.baseUrlFor(id));
        return response.data;
    }

    public async getCount(options: any): Promise<API.GetTagCount> {
        const response = await this.api.get<API.GetTagCount>(this.baseUrlFor('count'), {
            params: {
                ...options,
            },
        });
        return response.data;
    }

    public async remove(id: string): Promise<API.DeleteTag> {
        const response = await this.api.delete<API.DeleteTag>(this.baseUrlFor(id));
        return response.data;
    }

    public async isLabelAvailable(label: string, agencyId: string): Promise<API.IsTagLabelAvailable> {
        const response =  await this.api.get<API.IsTagLabelAvailable>(this.baseUrlFor('is_label_available'), {
            params: {
                label,
                agencyId,
            },
        });

        return response.data;
    }

    public createInstance(tag: any): Tag {
        const tagInstance = new Tag(tag);
        if (tagInstance.agency) {
            tagInstance.agency = new Agency(tagInstance.agency);
        }

        if (tagInstance.createdBy) {
            tagInstance.createdBy = new User(tagInstance.createdBy);
        }

        if (tagInstance.updatedBy) {
            tagInstance.updatedBy = new User(tagInstance.updatedBy);
        }

        return tagInstance;
    }
}

export const tagApi = new TagApi();
